import React from 'react'

const Header = ({ header }) => {
  return (
    <h5 className={'p_header_text text-inky-blue text-start mb-0 '+ header?.CssClass}>{header?.Value}</h5>
  )
}

export default Header